import { types } from 'mobx-state-tree';

export const SourceMarketPlaceSelect = types.model({}).actions(self => ({
  toggleSellectAllSourceMarketPlaces(listLength) {
    if (self.sourceMarketPlaceIds.length === listLength) {
      self.sourceMarketPlaceIds = [];
    } else {
      self.sourceMarketPlaceIds = self.sourceMarketPlaces.map(({ id }) => id);
    }
  },
  selectSourceMarketPlace(id) {
    const exist = self.sourceMarketPlacesObj[id] !== undefined;
    if (exist) {
      self.removeSourceMarketPlaceId(id);
    } else {
      self.setSourceMarketPlaceId(id);
    }
  },
  removeSourceMarketPlaceId(id) {
    self.sourceMarketPlaceIds = [...self.sourceMarketPlaceIds].filter(s => s !== id);
  },
  setSourceMarketPlaceId(id) {
    self.sourceMarketPlaceIds = [...self.sourceMarketPlaceIds, id];
  },
}));

export default SourceMarketPlaceSelect;
